import React from 'react'
import "./CopyPlan.css"
import { X } from 'lucide-react'

function CopyPlanMenu({onClose, onCopy, copyFeedback}) {
  console.log('copyFeedback:', copyFeedback);
  return (
    <>
    {copyFeedback ? ( <div className='copy-menu-feedback'><p className='copy-menu-feedback-text'> Plan details copied. </p></div> ) : (
  <div className='copy-plan-menu-container'>
  <div className="copy-plan-menu-item">
    <p className="copy-plan-menu-title">Select dates to copy</p>
  </div>
  <div className="copy-plan-menu-item">
    <button className="copy-plan-menu-button" onClick={onCopy}>Copy Plan</button>
  </div>
  <div className="copy-plan-menu-item">
    <button className="copy-plan-menu-close-btn" aria-label="Close" onClick={onClose}>
      <X size={16} />
    </button>
  </div>
</div>
    )}
    </>
  );
}

export default CopyPlanMenu